export default function LegalPage({ title, children }) {
  return (
    <section className="section" style={{ paddingTop: 80 }}>
      <div className="container" style={{ maxWidth: 720 }}>
        <h1 style={{ fontSize: "clamp(26px, 3vw, 34px)", marginBottom: 24 }}>{title}</h1>
        <div style={{ display: "flex", flexDirection: "column", gap: 20, fontSize: 15, lineHeight: 1.7, color: "var(--slate)" }}>
          {children}
        </div>
      </div>
    </section>
  );
}
